import { Box, CircularProgress, Tooltip, useTheme } from '@mui/material';
import React, { FC } from 'react';

import { Workflow } from '@apiContract';
import { isBarcodeLoading, tooltips } from '@components/Capture/helper';
import { CommonStyles, StyledIcon, sxMR0 } from '@components/Capture/icons/styles';
import { CapturePiece } from '@components/Capture/types';
import noop from 'lodash/fp/noop';
import path from 'lodash/fp/path';

import { BarcodeIcon } from '@src/assets/icons/BarcodeIcon';
import { getBarcodeIconColor } from '@utils/annotations';

interface IBarcodeLocalIconProps {
  capturePiece: CapturePiece | null;
  onClick?: () => void;
  workflow?: Workflow;
}

const BarcodeLocalIcon: FC<IBarcodeLocalIconProps> = ({ onClick, capturePiece, workflow }) => {
  const theme = useTheme();
  if (!capturePiece) {
    return null;
  }
  const { piece } = capturePiece;

  const color =
    !!capturePiece?.piece && !capturePiece?.pieceAnnotations
      ? undefined
      : getBarcodeIconColor(capturePiece.pieceAnnotations || [], workflow);
  const themeColor = color ? path(['palette', color, 'main'], theme) : undefined;
  const isLoading = isBarcodeLoading(
    capturePiece?.piece,
    capturePiece?.pieceAnnotations,
    capturePiece?.barcodeDetected,
  );

  return (
    <Box onClick={!piece ? noop : onClick} sx={{ ...CommonStyles, ...sxMR0 }}>
      <Tooltip title={tooltips.Barcode} arrow>
        <BarcodeIcon sx={StyledIcon(!piece ? 'action.disabled' : themeColor)} />
      </Tooltip>
      {isLoading && <CircularProgress />}
    </Box>
  );
};

export { BarcodeLocalIcon };
